export function strictFunc(values: any, expression: string): any {
    'use strict';
    try {
        const tempFn = new Function('values', 'return ' + expression);
        return tempFn(values);
    } catch (e) {
        return false;
    }
}
